/* Force CJS resolve — webpack sometimes sees ESM re-exports as empty */
const { SocketIO, Local } = require('boardgame.io/multiplayer');

export { SocketIO, Local };
